var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"demo"}},[_c('div',{staticClass:"div div1"}),_c('div',{staticClass:"div div2"}),_c('button',{on:{"click":_vm.buttonClick}},[_vm._v("点击")])])}
var staticRenderFns = []

export { render, staticRenderFns }